import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ["en", "zh-CN", "zh-TW"],

  // Used when no locale matches
  defaultLocale: "en",

  // Only show prefix for non-default locales
  // / = English, /cn = Chinese Simplified, /tw = Chinese Traditional
  localePrefix: {
    mode: "as-needed",
    prefixes: {
      "zh-CN": "/cn",
      "zh-TW": "/tw",
    },
  },
});
